module.exports = __webpack_public_path__ + "img/live-youtube.05227abf.png";